export const STATUS_COLORS = {
  available: "#3E7A5E",
  reserved: "#C79A3B",
  conditional: "#B0632B",
  sold: "#8A4B4B",
  future_release: "#5B6B7A",
  under_development: "#4A7BA5",
};
export const STATUS_LABELS = {
  available: "Available",
  reserved: "Reserved",
  conditional: "Conditional Sale",
  sold: "Home Coming",
  future_release: "Future Release",
  under_development: "Under Development",
};
export const USE_LABELS = {
  residential: "Residential",
  commercial: "Commercial",
  apartment: "Apartment / Multi-family",
  infrastructure: "Infrastructure",
  green_public: "Green / Public Space",
};
export const USE_COLORS = {
  residential: "#3E7A5E",
  commercial: "#B0632B",
  apartment: "#7A5BA5",
  infrastructure: "#5B6B7A",
  green_public: "#5B6B4E",
};
export const PHASES = ["Planning", "Approvals", "Servicing", "Construction", "Available", "Completed"];
export const STATUS_LIST = Object.keys(STATUS_LABELS);
export const USE_LIST = Object.keys(USE_LABELS);
